import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aed81af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BoxList" }
const _hoisted_2 = { class: "condition" }
const _hoisted_3 = { class: "TransportBoxes" }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = {
  key: 0,
  class: "CalculateBoxType"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('发货仓'), -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('分拣中心') + ":", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('目的地站') + ":", -1))
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('类型'), -1))
const _hoisted_14 = { key: 4 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('总金额'), -1))
const _hoisted_16 = { style: {"color":"red","display":"flex","justify-content":"space-between","flex":"1"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_18 = {
  key: 0,
  style: {"flex":"1","text-align":"center"}
}
const _hoisted_19 = {
  key: 5,
  class: "more"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('件数'), -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('货物类型'), -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('体积'), -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('实际重量'), -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('体积重量'), -1))
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('实际重量') + "/1000kg", -1))
const _hoisted_29 = { key: 3 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('国际运费'), -1))
const _hoisted_31 = { key: 4 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('木架费'), -1))
const _hoisted_33 = { key: 5 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('到付运费'), -1))
const _hoisted_35 = { key: 6 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('到付货款'), -1))
const _hoisted_37 = { key: 7 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('国内吊车费'), -1))
const _hoisted_39 = { key: 8 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('国外吊车费'), -1))
const _hoisted_41 = { key: 9 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('总金额'), -1))
const _hoisted_43 = { style: {"color":"red"} }
const _hoisted_44 = { class: "BoxDetailList" }
const _hoisted_45 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_46 = { class: "image-slot" }
const _hoisted_47 = { class: "GoodName" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "ProductPagination" }
const _hoisted_50 = { class: "Box_Affix" }

import { ref, onMounted, watch, toRefs } from 'vue'
import moment from 'moment'
import PaginationHook from '@/hooks/pagination'
import * as Api from '@/utils/api'
import { formatDate, textContent } from '@/utils/format'
import Pay from '@/components/user-center/pay.vue'
import Delivery from '@/components/user-center/delivery.vue'
import EmptyArray from '@/components/EmptyArray.vue'
import Loading from '@/components/loading.vue'
import { SiteSet } from '@/utils/siteConfig'
import { useUsersStore } from '@/pinia'
import { shortcuts } from '@/utils/constant'
import useClipboard from 'vue-clipboard3'
import { ElMessageBox } from 'element-plus'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'user_box_list',
  setup(__props) {

const { t } = useI18n()
const { toClipboard } = useClipboard()
const country = SiteSet().getPlacePredictions
const store = useUsersStore()
const { PaymentStatus, Entries } = toRefs(store)
const checkList = ref([])
const Types = ref([
  {
    name: '全部',
    val: null,
  },
  {
    name: '等待付款',
    val: false,
  },
  {
    name: '已经付款',
    val: true,
  },
])
const isType = ref(null)
const isEntrie = ref(null)
const isDate = ref(null)
const TransportBoxes = ref(null)
const total = ref(0)
const SelectAll = ref(false)
const BoxTotalAmount = ref(0)
const ShowPay = ref(false)
const PayDate = ref({
  TotalAmount: 0,
})
const Ids = ref(null)

const copy = (text) => {
  toClipboard(text)
  ElMessageBox.alert(t('已复制到粘贴板'), 'Tips', {
    confirmButtonText: 'OK',
  })
}

const FreightTypeColor = (id) => {
  let color = ''
  switch (id) {
    case 15:
      color = '#000'
      break;
    case 5:
      color = '#F79646'
      break;
    default:
      color = '#00B050'
      break;
  }
  return color
}

const PayDelivery = () => {
  Ids.value = []
  PayDate.value.TotalAmount = BoxTotalAmount.value
  checkList.value.map((ele) => {
    Ids.value.push(ele.BoxId)
  })
  ShowPay.value = true
}

const DeliveryDate = ref(null)
const ShowDelivery = ref(false)
const InitiateDelivery = () => {
  DeliveryDate.value = checkList.value
  ShowDelivery.value = true
}

const DeliveryChange = (val) => {
  ShowDelivery.value = false
  DeliveryDate.value = []
  if (val) {
    GetBox()
  }
}

watch(
  () => PaymentStatus.value,
  (res) => {
    GetBox()
  },
  {
    deep: true,
  }
)

const CheckAll = (val: CheckboxValueType) => {
  const newArry = TransportBoxes.value.filter(e => e.IsCheckPay || !e.IsDelivery);
  checkList.value = val ? newArry : []
  SelectCalculation()
}

const checkboxChange = (value) => {
  const checkedCount = value.length
  SelectAll.value = checkedCount === TransportBoxes.length
  SelectCalculation()
}

const SelectCalculation = () => {
  BoxTotalAmount.value = 0
  checkList.value.map((e) => {
    BoxTotalAmount.value += e.TotalAmount
  })
}

const Boxdetial = (detial) => {
  if (detial.more) {
    Api.Get('orders/api/TransportBox/', {
      BoxSerialNo: detial.Serail,
    }).then((res: any) => {
      detial.BoxDetailList = res.BoxDetailList
    })
  }
}

const GetBox = () => {
  SelectAll.value = false
  BoxTotalAmount.value = 0
  TransportBoxes.value = null
  const body = {
    page_size: pageSize.value,
    page_index: pageNum.value,
    from_date: isDate.value[0],
    to_date: isDate.value[1],
    status_id:
      typeof isType.value == 'boolean'
        ? textContent(isType.value)
        : isType.value,
    pick_up_id: '0',
    good_statu_id: isEntrie.value,
  }
  Api.Get('orders/api/TransportBoxByNew/', body).then((res: any) => {
    checkList.value = []
    TransportBoxes.value = res.TransportBoxes
    total.value = res.TotalRecordsCount
  })
}

const { pageNum, pageSize, handleCurrentChange, handleSizeChange } =
  PaginationHook(GetBox)

onMounted(() => {
  isDate.value = [
    moment().subtract(3, 'months').format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD'),
  ]

  pageSize.value = 10

  store.setState(
    'basic/api/Dictionary/',
    { dictionary_unique_id: 'A38CDD9A-4C80-45DF-AFAB-8574937F3FF8' },
    'Entries'
  )

  GetBox()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_CaretTop = _resolveComponent("CaretTop")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_radio_group, {
          modelValue: isEntrie.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isEntrie).value = $event)),
          onChange: GetBox
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: null }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('全部')), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Entries)?.Entries, (entrie) => {
              return (_openBlock(), _createBlock(_component_el_radio_button, {
                key: entrie.value,
                label: entrie.Id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(entrie.Name), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio_group, {
          modelValue: isType.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isType).value = $event)),
          onChange: GetBox
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Types.value, (type) => {
              return (_openBlock(), _createBlock(_component_el_radio_button, {
                key: type['value'],
                label: type.val
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(type.name)), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_date_picker, {
            modelValue: isDate.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isDate).value = $event)),
            type: "daterange",
            clearable: false,
            "value-format": "YYYY-MM-DD",
            "unlink-panels": "",
            "range-separator": "——",
            "start-placeholder": "Start date",
            "end-placeholder": "End date",
            shortcuts: _unref(shortcuts),
            onChange: GetBox
          }, null, 8, ["modelValue", "shortcuts"])
        ])
      ]),
      _createVNode(_Transition, { name: "el-fade-in-linear" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox_group, {
              modelValue: checkList.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checkList).value = $event)),
              onChange: checkboxChange,
              "value-key": "OrderNo"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TransportBoxes.value, (detial, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass([
            'TransportBoxe',
            { Boxtype1: detial.InStockStatuId == 15 },
            { Boxtype2: detial.IsReceTimeOut },
          ])
                  }, [
                    _createVNode(_component_el_card, {
                      onClick: ($event: any) => {detial.more = !detial.more; Boxdetial(detial)}
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("p", null, [
                          _createElementVNode("div", _hoisted_4, [
                            (_openBlock(), _createBlock(_component_el_checkbox, {
                              disabled: !detial.IsCheckPay && detial.IsDelivery,
                              label: detial,
                              key: detial.OrderNo,
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                            }, {
                              default: _withCtx(() => []),
                              _: 2
                            }, 1032, ["disabled", "label"])),
                            _createVNode(_component_el_text, {
                              onClick: [
                                _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                                ($event: any) => (copy(detial.Serail))
                              ]
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(detial.Serail) + " (" + _toDisplayString(_ctx.$t(
                        detial.PackageCount === 1
                          ? '单件'
                          : detial.CalculateTypeId === 20
                            ? '多件'
                            : '集包'
                      )) + ") ", 1),
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CopyDocument)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              (detial.more)
                                ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                            ]),
                            _: 2
                          }, 1024),
                          (detial.CalculateBoxType)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(detial.CalculateBoxType), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_ion_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    _createElementVNode("span", null, _toDisplayString(detial.FreightType), 1),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle([{ color: FreightTypeColor(detial.InStockStatuId) }, { fontSize: '16px' }])
                                    }, _toDisplayString(detial.InStockStatus), 5)
                                  ]),
                                  (detial.StockOutOn)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                        _hoisted_7,
                                        _createElementVNode("span", null, _toDisplayString('中国') + " (" + _toDisplayString(_unref(formatDate)(detial.StockOutOn, 'yyyy-MM-dd')) + ") ", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (detial.ConfirmReceTime)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                        _hoisted_9,
                                        _createElementVNode("span", null, _toDisplayString(detial.ConfirmReceCity) + " (" + _toDisplayString(_unref(formatDate)(detial.ConfirmReceTime, 'yyyy-MM-dd')) + ") ", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (detial.ReceivedOn)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("span", null, _toDisplayString(detial.WarehouseName) + " (" + _toDisplayString(_unref(formatDate)(detial.ReceivedOn, 'yyyy-MM-dd')) + ") ", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (detial.PickUpType)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                        _hoisted_13,
                                        _createElementVNode("span", null, _toDisplayString(detial.PickUpType), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                      detial &&
                      detial.TotalAmount > 0 &&
                      !detial.more
                    )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                        _hoisted_15,
                                        _createElementVNode("span", _hoisted_16, [
                                          _hoisted_17,
                                          (detial.DiscountAmount)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString('已优惠') + " " + _toDisplayString(_ctx.$ccy(detial.DiscountAmount)), 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.TotalAmount)), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (detial.more)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createElementVNode("p", null, [
                                          _hoisted_20,
                                          _createElementVNode("span", null, _toDisplayString(detial.PackageCount), 1)
                                        ]),
                                        (detial.ShippingMark)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                              _hoisted_22,
                                              _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(detial.ShippingMark, 'yyyy-MM-dd')), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("p", null, [
                                          _hoisted_23,
                                          _createElementVNode("span", null, _toDisplayString(detial.Size) + "m³", 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_24,
                                          _createElementVNode("span", null, _toDisplayString(detial.Weight) + "kg", 1)
                                        ]),
                                        (detial.QuoteTypeId === 1)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                                              _hoisted_26,
                                              _createElementVNode("span", null, _toDisplayString(detial.VolumeWeight) + "kg", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.QuoteTypeId !== 1)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                              _hoisted_28,
                                              _createElementVNode("span", null, _toDisplayString(detial.WeightVolume) + "m³", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.ShouldIncomeCN2THFreightAmount > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                              _hoisted_30,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.CN2THFreightAmount)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.UsdBoxCost > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                              _hoisted_32,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.UsdBoxCost)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.UsdBoxFreight > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                              _hoisted_34,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.UsdBoxFreight)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.UsdBoxGoodPayment > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                              _hoisted_36,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.UsdBoxGoodPayment)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.CnForkliftFee > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                                              _hoisted_38,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.CnForkliftFee)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.KhForkliftFee > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                                              _hoisted_40,
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(detial.KhForkliftFee)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (detial.TotalAmount > 0)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                                              _hoisted_42,
                                              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$ccy(detial.TotalAmount)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detial.BoxDetailList, (product) => {
                                          return (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                              _createVNode(_component_el_image, {
                                                style: {"width":"80px"},
                                                fit: "scale-down",
                                                src: product.GoodImgUrl
                                              }, {
                                                error: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_46, [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Picture)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["src"]),
                                              _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("div", {
                                                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                                }, [
                                                  _createElementVNode("span", {
                                                    onClick: ($event: any) => (copy(product.OrderNo))
                                                  }, [
                                                    _createTextVNode(_toDisplayString(product.OrderNo) + " ", 1),
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_CopyDocument)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ], 8, _hoisted_48),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(product.Price)), 1)
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("span", null, _toDisplayString(product.GoodName), 1),
                                                  _createElementVNode("span", null, "x" + _toDisplayString(product.Quantity), 1)
                                                ])
                                              ])
                                            ])
                                          ]))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 2))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, TransportBoxes.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(EmptyArray, {
        show: TransportBoxes.value && !TransportBoxes.value.length
      }, null, 8, ["show"]),
      _withDirectives(_createVNode(Loading, { type: "13" }, null, 512), [
        [_vShow, !TransportBoxes.value]
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(pageNum),
          "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(pageNum) ? (pageNum).value = $event : null)),
          "page-size": _unref(pageSize),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange),
          total: total.value,
          background: "",
          layout: "prev, pager, next"
        }, null, 8, ["currentPage", "page-size", "onSizeChange", "onCurrentChange", "total"])
      ])
    ]),
    _withDirectives(_createVNode(_component_el_affix, {
      ref: "affix",
      position: "bottom",
      offset: 0
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_checkbox, {
              style: {"color":"white !important"},
              modelValue: SelectAll.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((SelectAll).value = $event)),
              onChange: CheckAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('全选')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _withDirectives(_createElementVNode("span", { class: "totalAmount" }, _toDisplayString(_ctx.$ccy(BoxTotalAmount.value)), 513), [
              [_vShow, !isType.value]
            ]),
            _createVNode(_component_el_button, {
              size: "large",
              type: "danger",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (!isType.value ? PayDelivery() : InitiateDelivery()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(!isType.value ? '支付' : '发起配送')), 1)
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, checkList.value.length > 0]
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, isType.value != null && TransportBoxes.value && TransportBoxes.value.length != 0]
    ]),
    _createVNode(Delivery, {
      Date: DeliveryDate.value,
      ShowDelivery: ShowDelivery.value,
      onDeliveryChange: DeliveryChange
    }, null, 8, ["Date", "ShowDelivery"]),
    _createVNode(Pay, {
      Date: PayDate.value,
      ShowPay: ShowPay.value,
      Ids: Ids.value,
      PayType: "Box",
      onPayChange: _cache[10] || (_cache[10] = ($event: any) => (ShowPay.value = false))
    }, null, 8, ["Date", "ShowPay", "Ids"])
  ], 64))
}
}

})